import React from 'react';
import './EmptyState.css';

const EmptyState = ({ message, action, icon }) => {
  return (
    <div className="p-empty">
      {icon && <span className="p-empty__icon">{icon}</span>}
      <p className="p-empty__message">{message}</p>
      {action && <div className="p-empty__action">{action}</div>}
    </div>
  );
};

export default EmptyState;
